<template>
    <div>
        <b-modal :id="modalId"
            @hidden="onModalHidden()"
                modal-class="modal-register-success"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc>
                <div class="modal-base">
                    <!-- :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}" -->
                    <div class="modal-base-head">
                        <img v-if="welcomepoint > 0" class="img-top-coin" src="@/assets/image/Register/img-ribbon-coin-new.png" alt="">
                        <img v-else class="img-top-ribbon" src="@/assets/image/Register/img-ribbon-new.png" alt="">
                        <div class="circle-bg-top">
                            <div>
                                <img class="nv_logo_cp_img" src="@/assets/logo/cpf-logo.png" />
                            </div>
                            <!-- <div class="nv_logo_cp_img"
                                :style="{'background-image': 'url(' + cpflogo + ')'}"></div> -->
                        </div>
                    </div>
                    <div class="modal-base-body">
                        
                        <div class="wrapper-body">
                            <div class="text-welcome">{{title}}</div>
                            <div class="text-point">{{message}}</div>
                        </div>
                        <div>
                            <div class="btn-wrapper"
                                    @click="clickOk()">
                                <div class="btn-txt">
                                    เริ่มต้นใช้งาน
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
    </div>
</template>
<script>
// import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";

/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: 'RegisterSuccessModal',
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
        theme: String
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            welcomepoint: 0,
            btnOk: '',
            btnCancel: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.welcomepoint = config.point;
            this.message = Util.stringFormat(config.msg, this.welcomepoint);
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    @import "@/style/base/base.scss";

    .modal-register-success{
        @extend %modal-base;

        .modal-dialog .modal-content .modal-body{
            padding: 0;

            .modal-base{
                position: relative;
                padding: 24px;
                .modal-base-head {
                    .img-top-coin {
                        position: absolute;
                        top: -9rem;
                        left: -35px;
                        right: 0;
                        margin: auto;
                        width: 100%;
                        min-width: 350px;
                        height: 140px;

                        @media (min-width: $min-width-m-mobile) {
                            left: -30px;
                        }
                    }
                    .img-top-ribbon {
                        position: absolute;
                        top: -8.5rem;
                        left: -26px;
                        right: 0;
                        margin: auto;
                        // width: 100%;
                        min-width: 262px;
                        height: 106px;

                        @media (min-width: 414px) {
                            left: -10px;
                        }
                    }
                    .circle-bg-top{
                        position: absolute;
                        top: -80px;
                        left: 0;
                        right: 0;
                        margin: auto;
                        background-color: $green-00987F;
                        border-radius: 100%;
                        width: 110px;
                        height: 110px;

                        .nv_logo_cp_img {
                            // @include translateKit(-50%, -50%);
                            position: absolute;
                            top: 10px;
                            left: 0;
                            right: 0;
                            margin: auto;
                            width: 90px;
                            // height: 100%;
                            background-position: center center;
                            background-repeat: no-repeat;
                            background-size: 100%;
                        }
                    }
                }
                .modal-base-body{
                    // position: relative;
                    // padding: 24px;
                    // &.theme-bg-color{
                    //     border-radius: 15px;

                    //     @mixin bg-welcome-cp ($bg_url) {
                    //         background-image: url($bg_url);
                    //         background-position: bottom -2px center;
                    //         background-repeat: no-repeat;
                    //         background-size: 101%;
                    //         min-height: 410px;
                    //     };

                    //     &.farmer, &.subdist{
                    //         @include bg-welcome-cp('../../../../assets/image/Register/bg_welcome1.png');
                    //     }
                    //     &.dist {
                    //         @include bg-welcome-cp('../../../../assets/image/Register/bg_welcome2.png');
                    //     }
                    //     &.sale {
                    //         @include bg-welcome-cp('../../../../assets/image/Register/bg_welcome3.png');
                    //     }
                    // }

                    .wrapper-body{
                        padding: 50px 20px 20px;
                        text-align: center;

                        .icon-close{
                            position: absolute;
                            top: 10px;
                            right: 15px;

                            img{
                                width: 20px;
                            }
                        }

                        

                        .text-welcome{
                            font-size: 1.75rem;
                            color: $green-00987F;
                            font-family: $semi_bold;
                        }
                        .text-point{
                            font-size: 1.5rem;
                            color: $a-gray-575757;
                            margin: 16px 0 0;
                        }
                    }
                    .btn-wrapper {
                        @include btn-wrapper(#ffffff, $green-00987F);
                    }
                }
            }
        }
    }
</style>
